class OneToolsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.activate(next);
        this.tabs[next].focus();
      });
    });

    const sort = this.querySelector('[data-tool-sort]');
    if (sort) sort.addEventListener('change', () => this.sortActivePanel(sort.value));
  }

  activate(index) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = index === tabIndex;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
    const sort = this.querySelector('[data-tool-sort]');
    if (sort) this.sortActivePanel(sort.value);
  }

  sortActivePanel(mode) {
    const panel = this.panels.find((item) => !item.hidden);
    const grid = panel && panel.querySelector('[data-product-grid]');
    if (!grid) return;
    const cards = Array.from(grid.children);
    cards.sort((a, b) => {
      if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
      if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
      if (mode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
      return Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder);
    });
    cards.forEach((card) => grid.appendChild(card));
  }
}

if (!customElements.get('one-tools-tabs')) {
  customElements.define('one-tools-tabs', OneToolsTabs);
}

document.addEventListener('click', (event) => {
  const menu = document.querySelector('.ot-mobile-drawer[open]');
  if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
});
